/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { MaxDelayModeConfig } from './max-delay-mode-config';
// May contain unused imports in some cases
// @ts-ignore
import { OperatingPoint } from './operating-point';
// May contain unused imports in some cases
// @ts-ignore
import { PunctuationOverrides } from './punctuation-overrides';
// May contain unused imports in some cases
// @ts-ignore
import { RealtimeDiarizationConfig } from './realtime-diarization-config';
// May contain unused imports in some cases
// @ts-ignore
import { RealtimeSpeakerDiarizationConfig } from './realtime-speaker-diarization-config';
// May contain unused imports in some cases
// @ts-ignore
import { VocabWord } from './vocab-word';

/**
 *
 * @export
 * @interface RealtimeTranscriptionConfig
 */
export interface RealtimeTranscriptionConfig {
  /**
   *
   * @type {Array<VocabWord>}
   * @memberof RealtimeTranscriptionConfig
   */
  additional_vocab?: Array<VocabWord>;
  /**
   *
   * @type {RealtimeDiarizationConfig}
   * @memberof RealtimeTranscriptionConfig
   */
  diarization?: RealtimeDiarizationConfig;
  /**
   * Request a specialized model based on \'language\' but optimized for a particular field, e.g. \"finance\" or \"medical\".
   * @type {string}
   * @memberof RealtimeTranscriptionConfig
   */
  domain?: string;
  /**
   *
   * @type {boolean}
   * @memberof RealtimeTranscriptionConfig
   */
  enable_entities?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RealtimeTranscriptionConfig
   */
  enable_partials?: boolean;
  /**
   *
   * @type {string}
   * @memberof RealtimeTranscriptionConfig
   */
  language: string;
  /**
   *
   * @type {number}
   * @memberof RealtimeTranscriptionConfig
   */
  max_delay?: number;
  /**
   *
   * @type {MaxDelayModeConfig}
   * @memberof RealtimeTranscriptionConfig
   */
  max_delay_mode?: MaxDelayModeConfig;
  /**
   *
   * @type {OperatingPoint}
   * @memberof RealtimeTranscriptionConfig
   */
  operating_point?: OperatingPoint;
  /**
   *
   * @type {string}
   * @memberof RealtimeTranscriptionConfig
   */
  output_locale?: string;
  /**
   *
   * @type {PunctuationOverrides}
   * @memberof RealtimeTranscriptionConfig
   */
  punctuation_overrides?: PunctuationOverrides;
  /**
   *
   * @type {number}
   * @memberof RealtimeTranscriptionConfig
   */
  speaker_change_sensitivity?: number;
  /**
   *
   * @type {RealtimeSpeakerDiarizationConfig}
   * @memberof RealtimeTranscriptionConfig
   */
  speaker_diarization_config?: RealtimeSpeakerDiarizationConfig;
}
